<vl-input-search-dialog
  (onClickSearch)="startSearch.set(true)"
  (close)="close.emit()"
  [(search)]="searchValue"/>
@if (startSearch()) {
  <div class="search-list-container">
    <div class="flex-col gap-12 search-list bg-disabled p-12">
      @if (allAisFiltered().length) {
        @for (ai of allAisFiltered(); track $index) {
          <vl-chips (action)="onSelectArticleId(ai.articleId)">
            {{ ai.denomination }}
          </vl-chips>
        }
      } @else {
        <div class="no-content">
            <span>
            Aucun article correspondant
            </span>
        </div>
      }
    </div>
    @if (allAisFiltered().length) {
      <div class="fading-bottom"></div>
    }
  </div>
}


<div class="justup-dialog" (click)="startSearch.set(false)">

  <vl-header-dialog [canClose]="false">

    {{ articleInfos()?.denomination }}

  </vl-header-dialog>

  <div class="justup-dialog-content">

    <div class="wrap-container gap-16 align-baseline p-8 sticky-filter">

      <vl-multi-date [value]="dateRange()" (valueChange)="onDateRangeChange($event)" [text]="'data.period' | trans"/>
      <vl-chips-toggle
        [elements]="periods()"
        [(value)]="period"
      />


    </div>

    <div class="flex-container p-16">

      <vl-dashboard-container [type]="TypeDashboard.SINGLE_ARTICLE" [editable]="false" [customLoading]="true"
                              [rowHeight]="100"/>
    </div>
  </div>
</div>


